module.exports = __webpack_public_path__ + "img/ndc-logo.be1a97f3.png";